import { Component, OnInit, ViewContainerRef, viewChild } from '@angular/core';
import { showHide } from '../../modal-animations';
import { Modal } from '../../modal';

@Component({
    selector: 'app-modal-template-default',
    templateUrl: './modal-template-default.component.html',
    styleUrls: ['./modal-template-default.component.scss'],
    animations: [showHide],
    standalone: false
})
export class ModalTemplateDefaultComponent extends Modal implements OnInit {

  readonly contentRef = viewChild('content', { read: ViewContainerRef });

  constructor() {
    super();
  }

  ngOnInit() {
  }

}
